
export const InterviewRoutes = [
    ////////////////////////////////////////////////////////////////////////////
    // 인터뷰 페이지 라우트
    ////////////////////////////////////////////////////////////////////////////
    {
        // 인터뷰 코드 페이지
        path: "/interview",
        component: () => import(/* webpackChunkName: "interview-enterance" */ "../pages/interview/InterviewCodePage.vue"),
        props: true,
    },
    {
        // 인터뷰 입장 페이지
        path: "/interview/:code",
        component: () => import(/* webpackChunkName: "interview-enterance" */ "../pages/interview/InterviewViewPage.vue"),
        props: true,
    },
];
